import {
  EmailAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
} from "firebase/auth"

import { app } from "./firebaseApp"

export const auth = getAuth(app)

export const observeAuthState = (callback: (user: any) => void) => onAuthStateChanged(auth, callback)

export const googleProvider = new GoogleAuthProvider()
export const appleProvider = new OAuthProvider("apple.com")
export const emailProvider = new EmailAuthProvider()
export const phoneProvider = new PhoneAuthProvider(auth)

export const signInWithEmail = (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password)
}

export const setUpRecaptcha = (elementId: string) => {
  return new RecaptchaVerifier(auth, elementId, {})
}
